<template>
    <div>
        <div id="ey-admissions-loan">
            <section class="admission-form">
                <div class="oa-container">
                    <div class="ey-logo" style="min-height: 130px;">
                        <a href="/">
<!--                            <img src="https://empoweryouth.com/assets/common/logos/logo.svg">-->
                        </a>
                    </div>
                    <div class="flex-main">
                        <div class="left-sec">
                            <h2>Get Admission In Your <br><span>Dream College</span> <br>Without Any Hassle</h2>
                            <div class="ls-divider"></div>
                            <h4 class="mb0 margin-top-20">Don’t Let Money Stop You From Getting into Your Dream
                                College!</h4>
                            <h4 class="mt10"><span class="colorOrange">Education Loans</span> available for
                                <span class="colorOrange">India</span> and <span class="colorOrange">Abroad</span>.</h4>
                            <div class="el-icons-flex">
                                <div class="el-icons">
                                    <img
                                        src="https://empoweryouth.com/assets/themes/ey/images/pages/custom/loan-application.png">
                                    <p>Online <br>Application</p>
                                </div>
                                <div class="el-icons">
                                    <img
                                        src="https://empoweryouth.com/assets/themes/ey/images/pages/custom/quick-sanction.png">
                                    <p>Quick <br>Sanction</p>
                                </div>
                                <div class="el-icons">
                                    <img
                                        src="https://empoweryouth.com/assets/themes/ey/images/pages/custom/collateral.png">
                                    <p>Collateral Free <br>Loans</p>
                                </div>
                            </div>
                            <h4 class="margin-top-20">Loan Starting from as low as 9% p.a.</h4>
                            <h3><span class="colorOrange">Interest Free Loans</span> available for <span
                                class="colorOrange">select Colleges/Universities</span>
                            </h3>
                        </div>
                        <div class="right-sec">
                            <div class="ls-box-shadow">
                                <p id="headingText">Fill Me For Your Bright Future</p>
                                <div class="form-group tab">
                                    <div class="form-flex">
                                        <input type="text" class="form-control field-req" id="applicant-name"
                                               placeholder="First Name" name="first_name" @blur="saveVal($event,'leadApplication')">
                                        <input type="text" class="form-control field-req" id="applicant-last-name"
                                               placeholder="Last Name" name="last_name" @blur="saveVal($event,'leadApplication')">
                                    </div>
                                    <div class="form-flex">
                                        <input type="text" class="form-control field-req" id="email"
                                               placeholder="Email" name="student_email" @blur="saveVal($event,'leadApplication')">
                                        <input type="text" class="form-control field-req" id="number"
                                               placeholder="Phone" name="phone" @blur="saveVal($event,'leadApplication')">
                                    </div>
                                    <div class="form-flex">
                                        <input type="text" class="form-control" id="course-name" placeholder="Course Name" name="course_name" @blur="saveVal($event,'leadApplication')">
                                    </div>
                                </div>
                                <div class="form-group tab">
                                    <section data-type="loan_interest">
                                        <div class="form-flex-2">
                                            <div class="font14">Would you like to take education loan for :</div>
                                            <div class="radio-container">
                                                <ul class="displayInline">
                                                    <li>
                                                        <label class="container-radio">
                                                            University/College
                                                            <input type="radio" name="loan_for" value="1" class="co-field" @change="saveVal($event,'leadApplication')">
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label class="container-radio">School
                                                            <input type="radio" name="loan_for" value="2" class="co-field" @change="saveVal($event,'leadApplication')">
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label class="container-radio">
                                                            Other Institute
                                                            <input type="radio" name="loan_for" value="3" class="co-field" @change="saveVal($event,'leadApplication')">
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <section>
                                            <div class="form-flex-2">
                                                <div class="font14">Have You Already Taken Admission?</div>
                                                <div class="radio-container">
                                                    <ul class="displayInline">
                                                        <li>
                                                            <label class="container-radio">Yes
                                                                <input type="radio" name="admission_taken" value="1" class="co-field" @change="takenAdmission(); saveVal($event,'leadApplication');">
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </li>
                                                        <li>
                                                            <label class="container-radio">No
                                                                <input type="radio" name="admission_taken" value="0" class="co-field" @change="takenAdmission(); saveVal($event,'leadApplication');">
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <div class="form-group" id="appliedYes" v-if="admissionTaken == 1">
                                                <div class="form-flex">
                                                    <input type="text" class="form-control" id="other-institute-name" placeholder="Other Institute Name" name="college_name" @blur="saveVal($event,'leadApplication')">
                                                </div>
                                            </div>
                                            <div class="form-group" id="appliedNo" v-if="admissionTaken == 0">
                                                <p>Please Mention Your Three Preferred Colleges</p>
                                                <div class="form-flex">
                                                    <input type="text" class="form-control" placeholder="Other Institute Name Preference 1" name="college_name" @blur="saveVal($event,'leadCollegePref',1)">
                                                </div>
                                                <div class="form-flex">
                                                    <input type="text" class="form-control" placeholder="Other Institute Name Preference 2" name="college_name" @blur="saveVal($event,'leadCollegePref',2)">
                                                </div>
                                                <div class="form-flex">
                                                    <input type="text" class="form-control" placeholder="Other Institute Name Preference 3" name="college_name" @blur="saveVal($event,'leadCollegePref',3)">
                                                </div>
                                            </div>
                                        </section>
                                    </section>

                                    <div class="form-group">
                                        <div class="form-flex-2">
                                            <div class="font14">Do You want to apply for Education Loan Now?</div>
                                            <div class="radio-container">
                                                <ul class="displayInline">
                                                    <li>
                                                        <label class="container-radio">Yes
                                                            <input type="radio" name="userLoanApply" value="0" class="co-field" @change="loanApply()">
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label class="container-radio">
                                                            No, I am Just Inquiring.
                                                            <input type="radio" name="userLoanApply" value="1" class="co-field" @change="loanApply()">
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div id="loanFields" v-if="userLoanApply == 1">
                                            <div class="form-flex">
                                                <input type="text" class="form-control" placeholder="Loan Amount" name="loan_amount" @blur="saveVal($event,'leadApplication')">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="button-form">
                                    <button type="button" class="btn-frm" id="prevBtn" @click="nextPrev(-1)">
                                        Previous
                                    </button>
                                    <button type="button" class="btn-frm" id="nextBtn" @click="nextPrev(1)">
                                        Next
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import toastr from "../../public/js/toastr";
import {requestHeaders} from "../_helpers/apiHelper";

export default {
    components: {},
    data: function () {
        return {
            currentTab: 0,
            admissionTaken:3,
            userLoanApply:0,
            app_id:'',
        }
    },
    mounted() {
        var t = this;
        t.showTab(t.currentTab);
    },
    methods: {
        validateForm: function () {
            var x, y, z, i, valid = true, a = this;
            x = document.getElementsByClassName("tab");
            y = x[a.currentTab].getElementsByClassName("field-req");
            for (i = 0; i < y.length; i++) {
                if (y[i].value == "") {
                    y[i].className += " invalid";
                    valid = false;
                } else {
                    y[i].classList.remove('invalid');
                }
            }
            var w = x[a.currentTab].getElementsByClassName("adhar");
            if (w.length) {
                for (i = 0; i < w.length; i++) {
                    var max_chars = 12,
                        regexp = /^\d+$/gs;
                    if (w[i].value.length != max_chars || !regexp.test(w[i].value)) {
                        w[i].className += " invalid";
                        valid = false;
                    } else {
                        w[i].classList.remove('invalid');
                    }
                }
            }
            // function limit(element)
            // {
            //   if(element.value.length > max_chars) {
            //     element.value = element.value.substr(0, max_chars);
            //   }
            //   if (!regexp.test(element.value)) {
            //     alert("Only numbers!");
            //     return false;
            //   }
            // }
            // z = x[a.currentTab].getElementsByTagName('select');
            // if (z.length > 0) {
            //     for (i = 0; i < z.length; i++) {
            //         if (z[i].value == "") {
            //             z[i].className += " invalid";
            //             valid = false;
            //         } else {
            //             z[i].classList.remove('invalid');
            //         }
            //     }
            // }
            // if (a.currentTab == 0) {
            //     if (document.getElementById('password').value != document.getElementById('con_password').value) {
            //         document.getElementById('password').className += " invalid";
            //         document.getElementById('con_password').className += " invalid";
            //         valid = false;
            //     }
            // }
            return valid;
        },
        showTab(n) {
            // This function will display the specified tab of the form...
            var x = document.getElementsByClassName("tab");
            x[n].style.display = "block";
            if (n == 0) {
                document.getElementById("prevBtn").style.display = "none";
                x[n + 1].style.display = "none";
            } else {
                document.getElementById("prevBtn").style.display = "inline";
            }
            if (n == (x.length - 1)) {
                document.getElementById("nextBtn").innerHTML = "Submit";
            } else {
                document.getElementById("nextBtn").innerHTML = "Next";
            }
        },
        nextPrev(n) {
            var t = this;
            var x = document.getElementsByClassName("tab");
            if (n == 1 && !t.validateForm()) {
                return false;
            }

            if (t.currentTab + n < x.length && t.currentTab + n != x.length) {
                x[t.currentTab].style.display = "none";
                t.currentTab = t.currentTab + n;
                t.showTab(t.currentTab);
            } else {
                toastr.warning('Application Saving', 'Processing');
                setTimeout(function (){
                    toastr.success('Application Successfully Submitted', 'Success');
                    alert('Application Successfully Submitted');
                    t.$router.push({path: '/'})
                }, 3000);
            }
        },
        saveVal(elem,type,seq = null){
            var element = elem.currentTarget;
            var elemValue = element.value;
            var elemName = element.name;
            if(elemValue === '' || elemValue === ' ' && element.classList.contains('field-req')){
                element.className += " invalid";
                return false;
            }
            var t = this;
            var url = this.$store.getters.getDomain;
            var obj = {};
            obj['app_enc_id'] = t.app_id;
            obj['type'] = type;
            obj[elemName] = elemValue;
            obj['seq'] = seq;
            axios.post(`${url}api/v2/loans/admission-form`, obj, {headers: requestHeaders()}).then(function (response) {
                if (response['data']['response']['status'] == 200) {
                    t.app_id = response['data']['response']['app_enc_id'];
                }
            });
        },
        takenAdmission(){
            var t = this;
            var elems = document.getElementsByName('admission_taken');
            for (var k = 0; k < elems.length; k++) {
                if (elems[k].checked) {
                    t.admissionTaken = elems[k].value;
                }
            }
        },
        loanApply(){
            var t = this;
            var elems2 = document.getElementsByName('userLoanApply');
            for (var m = 0; m < elems2.length; m++) {
                if (elems2[m].checked) {
                    t.userLoanApply = elems2[m].value;
                    if(elems2[m].value == 0){
                        toastr.warning('Application Saving', 'Processing');
                        setTimeout(function (){
                            toastr.success('Application Successfully Submitted', 'Success');
                            t.$router.push({path: '/'})
                        }, 3000);
                    }
                }
            }
        },
    },
}
</script>

<style scoped>
body {
    margin: 0px;
    padding: 0px;
    font-family: roboto;
}

.oa-container {
    max-width: 85vw;
    margin: 0 auto;
}

.admission-form {
    background: url('https://empoweryouth.com/assets/themes/ey/images/pages/custom/form-bg1.png') fixed;
    background-size: cover;
    min-height: 100vh;
    padding-bottom: 20px;
}

.ey-logo {
    text-align: center;
    padding-top: 50px;
    padding-bottom: 20px;
}

.ey-logo img {
    max-width: 200px;
}

.flex-main {
    display: flex;
    margin-top: 50px;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 20px;
}

.left-sec {
    flex-basis: 50%;
    padding-left: 50px;
}

.left-sec h2 {
    font-size: 30px;
    color: #333;
    line-height: 45px;
    margin-top: 0px;
    font-weight: 700;
}

.left-sec h2 span {
    font-size: 45px;
    color: #00a0e3
}

.right-sec {
    flex-basis: 50%;
}

.left-sec p {
    margin: 0
}

.ls-box-shadow {
    box-shadow: 0 0 10px rgba(0, 0, 0, .2);
    background: #fff;
    padding: 15px 20px 30px;
    max-width: 500px
}

.ls-box-shadow p {
    font-size: 21px;
    color: #333;
    text-align: center;
    font-family: roboto;
    font-weight: 500;
}

.right-sec form .form-group {
    width: 100%;
}

.margin-top-20 {
    margin-top: 20px !important;
}

.ls-divider {
    height: 2px;
    background: #666;
    max-width: 150px;
}

.el-icons-flex {
    display: flex;
}

.el-icons {
    text-align: center;
    margin: 0 30px 0 0px;
}

.el-icons p {
    font-size: 15px;
}

.left-sec h4 {
    color: #333;
    font-weight: 700;
    font-size: 15px;
    margin-bottom: 15px !important;
}

.left-sec h3 a {
    text-decoration: none;
    color: #333;
}

.form-control {
    margin: 10px 10px;
    padding: 12px 12px;
    background-color: #fff;
    /*border: 1px solid #c2cad8;*/
    width: calc(100% - 25px);
}

.form-control:focus {
    box-shadow: 0 0 5px rgba(0, 0, 0, .2);
    outline: none;
}

.colorOrange {
    color: #ff7803;
}

.colorBlue {
    color: #00a0e3;
}

.button-form {
    text-align: center;
    display: flex;
    justify-content: center;
}

.btn-frm {
    width: 100px;
    height: 40px;
    background-color: #00a0e3;
    border: 0px solid #c2cad8;
    color: #fff;
    border-radius: 6px;
    margin: 10px 5px 0;
    cursor: pointer;
}

.btn-frm:hover {
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.btn-frm:focus {
    outline: none;
}

.form-flex {
    display: flex;
    width: 100%;
    justify-content: center;
    align-content: center;
    margin: 0 auto;
    height: auto;
}

.form-flex-2 {
    display: flex;
    width: 100%;
    flex-direction: column;
    padding: 10px 10px 0;
}

.font14 {
    font-size: 15px;
}

.ff-input {
    margin: 0 5px;
    flex-basis: 50%;
}

.ff-input select {
    display: block;
    width: 100%;
}

.fw-input {
    margin: 0 5px;
    flex-basis: 100%;
}

.radio-container {
    display: flex;

}

.radio-container svg {
    width: 1.35rem;
    height: 1.35rem;
}

.radio-container svg.gear {
    order: 1;
    margin-left: 1.35rem;
    cursor: help;
}

.radio-container svg.gear:hover ~ h4 {
    transform: scale(1);
}

label {
    position: relative;
    margin: 0.675rem 1.35rem 0.675rem 0;
    display: flex;
    width: auto;
    align-items: center;
    cursor: pointer;
}

.check {
    margin-right: 7px;
    width: 1.35rem;
    height: 1.35rem;
}

.check #border, .check #border2 {
    fill: none;
    stroke: #7a7a8c;
    stroke-width: 3;
    stroke-linecap: round;
}

.check #dot, .check #dot2 {
    fill: url(#gradient);
    transform: scale(0);
    transform-origin: 50% 50%;
}

.check #dot2 {
    fill: url(#gradient2);
}

.radio-container input {
    display: none;
}

.radio-container input:checked + label {
    background: linear-gradient(180deg, #0db6fc, #00a0e3);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.radio-container input:checked + label svg #border,
.radio-container input:checked + label svg #border2 {
    stroke: url(#gradient);
    stroke-dasharray: 145;
    stroke-dashoffset: 145;
    animation: checked 500ms ease forwards;
}

.radio-container input:checked + label svg #border2 {
    stroke: url(#gradient2);
}

.radio-container input:checked + label svg #dot,
.radio-container input:checked + label svg #dot2 {
    transform: scale(1);
    transition: transform 500ms cubic-bezier(0.57, 0.21, 0.69, 3.25);
}

@keyframes checked {
    to {
        stroke-dashoffset: 0;
    }
}

.mb0 {
    margin-bottom: 0px !important;
}

.mt10 {
    margin-top: 10px !important;
}

.hideRow {
    display: none;
}

.tab {
    display: none;
}

.formActive {
    display: block !important;
}

#appliedNo p {
    font-size: 14px;
    text-align: left;
    margin-bottom: 0px;
    padding-left: 6px;
}

.displayInline li {
    display: inline-block;
    padding-right: 10px;
}

@media screen and (max-width: 1030px) {
    .flex-main {
        height: calc(100vh - 150px);
    }
}

@media screen and (max-width: 768px) {
    .flex-main {
        flex-direction: column;
        height: unset;
        padding-bottom: 30px;
    }

    .left-sec {
        flex-basis: 100%;
        padding-left: 00px;
        text-align: center;
        width: 100%;
        padding-top: 30px
    }

    .right-sec {
        flex-basis: 100%;
        width: 100%;
    }

    .ls-box-shadow {
        max-width: unset;
        width: auto;
    }

    .ls-divider {
        margin: 0 auto;
    }

    .el-icons-flex {
        justify-content: center;
        flex-wrap: wrap;
    }

    .el-icons {
        margin: 10px 15px 0 15px;
    }

    .admission-form {
        min-height: unset;

    }
}

.errorBox {
    border: 1px solid indianred;
}

@media screen and (max-width: 500px) {
    .left-sec h2 {
        font-size: 22px;
        line-height: 32px;
    }

    .left-sec h2 span {
        font-size: 30px;
    }
}
</style>